// extracted by mini-css-extract-plugin
export default {"BotomTimeLabel":"BottomTimeLabel_BotomTimeLabel__2lFl0"};